import PurchasePowerTeaserText from './PurchasePowerTeaserText'
import PurchasePowerTeaserScreen from './PurchasePowerTeaserScreen'

const PurchasePowerTeaser = {
  Text: PurchasePowerTeaserText,
  Screen: PurchasePowerTeaserScreen
}

export default PurchasePowerTeaser

export { PurchasePowerTeaserText, PurchasePowerTeaserScreen }
